import { CHANGE_LOCALE, SET_BREADCRUMB } from "./types";

/**
 * changeLocale - Changes the locale for the app
 * @param {string} locale - new Locale
 */
export const changeLocale = locale => dispatch =>
  dispatch({
    type: CHANGE_LOCALE,
    payload: {
      locale,
    },
  });

/**
 * setBreadcrumb - To save the breadcrumb on the global store
 * @param {array} breadcrumbs
 * @param {string} breadcrumb[].title - The title to show on the breadcrumb
 * @param {string} breadcrumb[].path - Path where it should go
 */
export const setBreadcrumb = breadcrumbs => dispatch =>
  dispatch({
    type: SET_BREADCRUMB,
    payload: {
      breadcrumbs,
    },
  });
